import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuthModal } from '../../context/AuthModalContext';
import { Wrapper, Box, Icon, Title, Sub, Btn } from './VerificarEmail.styles';

export default function VerificarEmail() {
  const [searchParams] = useSearchParams();
  const [estado, setEstado] = useState('cargando'); // cargando | ok | error
  const { openAuthModal } = useAuthModal();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) { setEstado('error'); return; }
    fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/verificar-email?token=${token}`)
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok }) => setEstado(ok ? 'ok' : 'error'))
      .catch(() => setEstado('error'));
  }, [searchParams]);

  return (
    <Wrapper>
      <Box>
        {estado === 'cargando' && (
          <>
            <Icon>⏳</Icon>
            <Title>Verificando tu cuenta...</Title>
          </>
        )}
        {estado === 'ok' && (
          <>
            <Icon>✅</Icon>
            <Title>¡Email verificado!</Title>
            <Sub>Ya puedes iniciar sesión en tu cuenta.</Sub>
            <Btn as="button" onClick={() => openAuthModal('signin')}>Iniciar sesión</Btn>
          </>
        )}
        {estado === 'error' && (
          <>
            <Icon>❌</Icon>
            <Title>Enlace inválido o caducado</Title>
            <Sub>Solicita un nuevo enlace de verificación desde el login.</Sub>
            <Btn as="button" onClick={() => openAuthModal('signin')}>Volver al login</Btn>
          </>
        )}
      </Box>
    </Wrapper>
  );
}
